import { History } from "history";
import React from "react";

/**
 * Create a history context object, so that we can easily inject references to
 * the history from our router into nested links.
 */
// tslint:disable-next-line variable-name
export const HistoryContext = React.createContext<History | undefined>(undefined);
